import React, { useEffect, useMemo, useState } from 'react';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ADMIN_STUDENT_RESULTS_API = process.env.REACT_APP_ADMIN_STUDENT_RESULTS_API || `${API_BASE_URL}/api/admin-app/student-results/`;

const AdminStudentResultsPage = () => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);

    const headers = useMemo(() => {
        const token = (localStorage.getItem('guest_access_token') || sessionStorage.getItem('guest_access_token') || '').trim();
        if (!token) {
            return null;
        }

        return {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        };
    }, []);

    useEffect(() => {
        const loadResults = async () => {
            if (!headers) {
                setLoading(false);
                return;
            }

            try {
                const response = await fetch(ADMIN_STUDENT_RESULTS_API, { headers });
                const data = response.ok ? await response.json() : [];
                setResults(Array.isArray(data) ? data : []);
            } catch (error) {
                setResults([]);
            } finally {
                setLoading(false);
            }
        };

        loadResults();
    }, [headers]);

    return (
        <div className="admin-panel-card admin-table-section">
            <h3>Student Results</h3>
            <p className="admin-subtitle">Submitted aptitude results from students.</p>
            <div className="admin-table-wrap">
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Student</th>
                            <th>Email</th>
                            <th>College</th>
                            <th>Test ID</th>
                            <th>Score</th>
                            <th>Correct</th>
                            <th>Answered</th>
                            <th>Submitted</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="8">Loading student results...</td></tr>
                        ) : results.length === 0 ? (
                            <tr><td colSpan="8">No student results found.</td></tr>
                        ) : (
                            results.map((row) => (
                                <tr key={row.id}>
                                    <td>{row.student_name || '-'}</td>
                                    <td>{row.student_email || '-'}</td>
                                    <td>{row.college_code || '-'}</td>
                                    <td>{row.test_id ?? '-'}</td>
                                    <td>{row.score ?? '-'} / {row.total_marks ?? '-'}</td>
                                    <td>{row.correct_count ?? '-'}</td>
                                    <td>{row.answered_count ?? '-'}</td>
                                    <td>{row.submitted_at ? new Date(row.submitted_at).toLocaleString() : '-'}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminStudentResultsPage;
